import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from 'src/appv2/modules/shared/shared.service';
import { IntegrationsService } from 'src/appv2/services/integrations.service';

@Component({
  selector: 'app-o-auth-redirect',
  templateUrl: './o-auth-redirect.component.html',
  styleUrls: ['./o-auth-redirect.component.scss']
})
export class OAuthRedirectComponent implements OnInit {

  constructor(
    public router: ActivatedRoute,
    private sharedService: SharedService,
    private integrationsService: IntegrationsService
  ) {
  }

  ngOnInit(): void {
    this.router.queryParamMap.subscribe((param: any) => {
      if (param.params.code) {
        localStorage.setItem('code', param.params.code);
        if (param.params['accounts-server']) {
          localStorage.setItem('accountServer', param.params['accounts-server']);
        }
        if (window.opener) {
          localStorage.setItem('redirectFromAuth', String(true));
          window.opener.location.reload(true);
          window.close();
        } else {
          const slug = window.location.pathname.split('.html')[0].slice(1);
          this.createIntegration(param.params.code, param.params['accounts-server'], slug);
        }
      } else if (param.params.error) {
        if (window.opener) {
          window.opener.location.reload(true);
          window.close();
        } else {
          window.location.href = '/bot-builder/integration/all-integrations/' + window.location.pathname.split('.html')[0].slice(1);
        }
      }
    });
  }


  createIntegration(code: string, server: string, slug: string) {
    if (slug === 'outlook') {
      this.outlook(code);
    } else if (slug === 'salesforce-crm') {
      this.salesForce(code);
    }  else if (['google-calendar', 'google-task', 'google-contacts', 'google-sheets'].includes(slug)){
      this.googleIntegration(code, slug);
    }
    else {
      this.zoho(code, server, slug);
    }

  }


  public async zoho(code: string, server: string, slug: string) {

    const category = slug === 'zoho-crm'
      ? 'crm'
      : slug;

    this.sharedService.loader('start');
    const payload = {
      code,
      account_domain: server
    };
    return this.integrationsService.createIntegration({ payload, category, slug })
      .catch((err: any) => {
        this.sharedService.showToast('error', '', err?.message);
      })
      .finally(() => {
        window.location.href = '/bot-builder/integration/all-integrations/' + window.location.pathname.split('.html')[0].slice(1);
      });
  }

  public async outlook(code: string) {
    this.sharedService.loader('start');
    const payload = {
      code,
      clientId: localStorage.getItem('clientId'),
      clientSecret: localStorage.getItem('clientSecret'),
    };
    return this.integrationsService
      .createIntegration({
        payload,
        category: 'crm',
        slug: 'outlook',
        integrationCredentials: code
      })
      .catch((err: any) => {
        this.sharedService.showToast('error', '', err?.message || 'Please enter valid Credentials');
      })
      .finally(() => {
        localStorage.removeItem('accountServer');
        localStorage.removeItem('domain');
        localStorage.removeItem('clientId');
        localStorage.removeItem('clientSecret');
        window.location.href = '/bot-builder/integration/all-integrations/outlook';
      });
  }

  public async salesForce(code: string) {
    this.sharedService.loader('start');

    const payload = {
      code,
      domain: localStorage.getItem('domain'),
      clientId: localStorage.getItem('clientId'),
      clientSecret: localStorage.getItem('clientSecret'),
    };

    return this.integrationsService
      .createIntegration({
        payload,
        category: 'crm',
        slug: 'salesforce-crm',
      })
      .catch((err: any) => {
        this.sharedService.showToast('error', '', err?.message || 'Please enter valid Credentials');
      })
      .finally(() => {
        localStorage.removeItem('clientId');
        localStorage.removeItem('clientSecret');
        localStorage.removeItem('domain');
        window.location.href = '/bot-builder/integration/all-integrations/salesforce-crm';
      });
  }

  public async googleIntegration(code: string, slug: string) {
    let category = slug;

    if (slug === 'google-calendar') {
       category = 'calendar';
    } else if (slug === 'google-task') {
       category = 'task';
    }
    this.sharedService.loader('start');
    return this.integrationsService.createIntegration({ code, category, slug })
      .catch((err: any) => {
        this.sharedService.showToast('error', '', err?.message);
      })
      .finally(() => {
        window.location.href = '/bot-builder/integration/all-integrations/' + slug;
      });
  }

}
